import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const ChevronDownIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 16" fill="none">
      <path d="M4 6L8 10L12 6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </BaseSVG>
  )
}
